import { faroCoreApiClient } from "@api/faro-core-api-client";
import { UserId } from "@custom-types/base-types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { RootState } from "@store/store-helper";

/**
 * Fetches the list of groups that a company member belongs to.
 * @throws {Error} if there is no selected company ID
 * @throws {HttpUtils.FetchError} if the Core API client request fails
 */
export const fetchCompanyMemberGroups = createAsyncThunk<
  FaroCoreApiTypes.GroupSummaryResponse[],
  { memberId: UserId },
  { state: RootState }
>(
  "companyMemberGroups/fetchCompanyMemberGroups",
  async ({ memberId }, { getState }) => {
    const {
      sdbCompany: { selectedSdbCompanyId },
    } = getState();

    if (!selectedSdbCompanyId) {
      throw new Error("No companyId was given to fetch company member groups");
    }
    
    return await faroCoreApiClient.groups.getCompanyMemberGroups({
      companyId: selectedSdbCompanyId,
      userIdentity: memberId,
    });
  },
  {
    condition: (_, api) => {
      // Skip fetching if groups have already been fetched
      return !api.getState().companyMemberGroups.groups;
    },
  }
);
